'use strict';

/**
 * JS dependencies
 */
import 'jquery';
import 'lodash';
import angular from 'angular';
/**
 * SearchJS related code
 */
import '../../../../../../../lib/assets/javascripts/devex/urls';
import '../../../../../../../lib/assets/javascripts/devex/browser_url';
import '../../../../../../../lib/assets/javascripts/devex/search/sorting';
import '../../../../../../../lib/assets/javascripts/devex/search/filter';
import '../../../../../../../lib/assets/javascripts/devex/search/pagination';
import '../../../../../../../lib/assets/javascripts/devex/search/searchJS';
/**
 * Modal and UI dependency
 */
import 'angular-ui-bootstrap';
/**
 * Component dependencies
 */
import '../../../../../components/consultant_search_result/consultant_search_result.module';
/**
 * AngularJs Services and Models
 */
import '../../../../../../../lib/assets/javascripts/devex/angular/services/routes.service';
import '../../../../../../../lib/assets/javascripts/devex/angular/models/alert_handling_service';
import '../../../../../../../lib/assets/javascripts/devex/alerts.js';
/**
 * Components templates
 */
import template from './discover_similar_profile.template.html?raw';
import modalTemplate from './discover_similar_profile_modal.template.html?raw';

let dependencies = [
  'ui.bootstrap.modal',
  'ui.bootstrap.tpls',
  'components.consultantSearchResult',
  'models.alertHandlingService',
  'services.RoutesService',
];

angular
  .module('peopleSearch.components.discoverSimilarProfile', dependencies)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put(template, template);
    $templateCache.put(modalTemplate, modalTemplate);
  }])
  .component('discoverSimilarProfile', {
    bindings: {
      selectedResults: '<',
    },
    controllerAs: 'vm',
    templateUrl: template,
    controller: [
      '$scope',
      '$uibModal',
      'alertHandlingService',
      'RoutesService',
      function ($scope, $uibModal, alertHandlingService, RoutesService) {
        var that = this;

        that.$uibModal = $uibModal;
        that.Routes = RoutesService;
        that.alertHandling = alertHandlingService;
        that.modalInstance = null;
        that.modalScope = null;
        that.mltSearchJs = null;
        /**
         * When user clicks on Discover more candidates button, run a new SearchJS search.
         *
         * @returns {undefined} Notify more_like_this_ids param change and run mltSearchJs search
         */
        that.discoverMoreLikeTheseConsultants = () => {
          that.mltSearchJs.filter.more_like_this_ids.setValue(Object.keys(that.selectedResults));

          that.mltSearchJs.notifyParamChange();
        };

        /**
         * Check if MLT search button should be enabled or disabled
         *
         * @returns {boolean} True if user selected more than 3 consultants, false if not
         */
        that.isMltSearchEnabled = () => {
          return Object.keys(that.selectedResults).length > 2;
        };

        /**
         * In this component, create a new SearchJS instance called `this.mltSearchJs`. Add
         * `more_like_this_ids` filter to it. Do not update URL on change. On query complete, open
         * a $uib modal instance to show consultants' results. On query error, show generic error
         * message.
         *
         * @returns {undefined}
         */
        that.setupMltSearchJs = () => {
          that.mltSearchJs = new devex.search.SearchJS({
            searchUrl: that.Routes.api_consultants_search_path(),
          });

          that.mltSearchJs.addFilter({
            name: 'more_like_this_ids',
            isArray: true,
          });

          that.mltSearchJs.enableUrlUpdate = false;

          that.mltSearchJs.on('queryComplete', (response) => {
            that.modalScope.consultants = response.data;
            that.modalInstance = that.$uibModal.open({
              animation: false,
              windowClass: 'discover-similar',
              templateUrl: modalTemplate,
              show: false,
              scope: that.modalScope,
              backdrop: 'static',
            });
          });

          that.mltSearchJs.on('queryException', that.alertHandling.showGenericErrorMessage);
        };

        /**
         * Generate a $scope for the modal. We'll then pass it to the $uib modal constructor so that
         * data can be properly displayed
         *
         * @returns {undefined}
         */
        that.generateModalScope = () => {
          /**
           * Create new scope
           *
           * @type {Object} this.modalScope
           */
          that.modalScope = $scope;

          /**
           * List of consultants to be displayed in the modal
           *
           * @type {null|Array} this.modalScope.consultants - Once populated, array of consultants
           */
          that.modalScope.consultants = null;

          /**
           * This Route function will be used together with the consultant ID to generate a link to
           * its details page
           *
           * @type {Function} this.modalScope.personPath - Used to generate link of the consultant's
           * name
           */
          that.modalScope.personPath = that.Routes.person_path;

          /**
           * Close modal instance.
           *
           * @returns {undefined} Function to close modal
           */
          that.modalScope.closeMltSearchModal = () => {
            that.modalInstance.close();
          };
        };

        /**
         * On $onInit AngularJS hook, set up SearchJs and generate a scope for the modal instance.
         *
         * @returns {undefined}
         */
        that.$onInit = function () {
          this.setupMltSearchJs();
          this.generateModalScope();
        };
      },
    ],
  });
